export type GetVideoTimecodeParams = {
  currentTime: number;
  frameCount?: number;
  totalTime?: number;
};

export const getVideoTimecode = ({ currentTime, frameCount, totalTime }: GetVideoTimecodeParams) => {
  if (Number.isNaN(currentTime) || currentTime <= 0) {
    return {
      frames: frameCount && totalTime ? 0 : undefined,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }

  const hours = Math.floor(currentTime / 3600);
  const minutes = Math.floor((currentTime % 3600) / 60);
  const seconds = Math.floor(currentTime % 60);
  const frames = frameCount && totalTime ? Math.floor((currentTime % 1) * (frameCount / totalTime)) : undefined;

  return {
    frames,
    hours,
    minutes,
    seconds,
  };
};
